import { render, staticRenderFns } from "./SaveDraftButton.vue?vue&type=template&id=32648bae&scoped=true&"
import script from "./SaveDraftButton.vue?vue&type=script&lang=js&"
export * from "./SaveDraftButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32648bae",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32648bae')) {
      api.createRecord('32648bae', component.options)
    } else {
      api.reload('32648bae', component.options)
    }
    module.hot.accept("./SaveDraftButton.vue?vue&type=template&id=32648bae&scoped=true&", function () {
      api.rerender('32648bae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/SaveDraftButton.vue"
export default component.exports